window.AjaxCall = function () {

    var _eventName = "";

    this.init = function (eventName) {
        _eventName = eventName;
    };

    this.call = function (formData) {

        document.body.classList.add("loadproducts", _eventName);

        const isFormData = formData instanceof FormData;
        var xhr = new XMLHttpRequest();
        xhr.open('POST', ajaxRequirements.ajaxUrl, true);

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) { // XMLHttpRequest.DONE
                document.body.classList.remove("loadproducts", _eventName);

                if (xhr.status === 200) {
                    var res = xhr.responseText;

                    try {
                        res = JSON.parse(res);
                    } catch (e) {
                        // Keep raw response text if backend does not return valid JSON.
                    }

                    document.dispatchEvent(new CustomEvent("AWWW_AJAX_SUCCESS"));

                    if (res) {
                        document.dispatchEvent(new CustomEvent(_eventName, {
                            detail: { state: "success", results: res }
                        }));
                    } else {
                        document.dispatchEvent(new CustomEvent(_eventName, {
                            detail: { state: "error" }
                        }));
                    }
                    
                    document.dispatchEvent(new CustomEvent("AWWW_PAGE_RELOAD_FIRST", {
                        detail: { results: res }
                    }));
                } else {
                    document.dispatchEvent(new CustomEvent(_eventName, {
                        detail: { state: "error" }
                    }));
                }
            }
        };

        if (isFormData) {
            xhr.send(formData);
        } else {
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify(formData || {}));
        }

        // Trigger events before sending the request
        document.dispatchEvent(new CustomEvent("AWWW_AJAX_BEFORE_SEND"));
        document.dispatchEvent(new CustomEvent(_eventName, {
            detail: { state: "before" }
        }));

        xhr.onloadend = function () {
            document.dispatchEvent(new CustomEvent("AWWW_AJAX_COMPLETE"));
            document.dispatchEvent(new CustomEvent(_eventName, {
                detail: { state: "complete" }
            }));
        };
    };
};